export enum ThemeVariableType {
  PrimaryColor = 'primary-color',
  PrimaryHoverColor = 'primary-hover-color',
  OnPrimaryColor = 'on-primary-color',
  OnPrimaryHoverColor = 'on-primary-hover-color',
  PrimaryContainerColor = 'primary-container-color',
  PrimaryContainerHoverColor = 'primary-container-hover-color',
  OnPrimaryContainerColor = 'on-primary-container-color',

  SecondaryColor = 'secondary-color',
  OnSecondaryColor = 'on-secondary-color',
  SecondaryContainerColor = 'secondary-container-color',
  OnSecondaryContainerColor = 'on-secondary-container-color',

  TertiaryColor = 'tertiary-color',
  OnTertiaryColor = 'on-tertiary-color',
  TertiaryContainerColor = 'tertiary-container-color',
  OnTertiaryContainerColor = 'on-tertiary-container-color',

  ErrorColor = 'error-color',
  OnErrorColor = 'on-error-color',
  ErrorContainerColor = 'error-container-color',
  OnErrorContainerColor = 'on-error-container-color',

  SurfaceDimColor = 'surface-dim-color',
  SurfaceColor = 'surface-color',
  SurfaceBrightColor = 'surface-bright-color',

  ContainerHighestColor = 'container-highest',
  ContainerHighColor = 'container-high',
  ContainerColor = 'container',
  ContainerLowColor = 'container-low',
  ContainerLowestColor = 'container-lowest',

  ContentBrightColor = 'content-bright',
  ContentLightColor = 'content-light',
  ContentNormalColor = 'content-normal',
  ContentDimColor = 'content-dim',
  ContentDarkColor = 'content-dark',
  ContentDarkestColor = 'content-darkest',

  UseScrollbarGradients = 'use-scrollbar-gradients',
  UseModernAuthLayout = 'use-modern-auth-layout',
  PreferBorders = 'prefer-borders',
  UseLightBadgeColors = 'use-light-badge-colors',
  LightBadgeNeutralChromaThreshold = 'light-badge-neutral-chroma-threshold',
  UseUnifiedMarkdownEditorBackground = 'use-unified-markdown-editor-background',
  ShouldUseLineStyleInFilters = 'should-use-line-style-in-filters',
  ShowNewMessageButtonOutsideInput = 'show-new-message-button-outside-input',
  ShowSidebarWorkspaceDropdownToggle = 'show-sidebar-workspace-dropdown-toggle',
  ShowSidebarFavouriteIconChips = 'show-sidebar-favourite-icon-chips',
  ShowCloudItemDetails = 'show-cloud-item-details',
  ShowCloudItemIcon = 'show-cloud-item-icon',
  ShowEmptyFilesPlaceholderVisual = 'show-empty-files-placeholder-visual',
  ShowEmptyConversationPlaceholderVisual = 'show-empty-conversation-placeholder-visual',
  ShowWorkspaceInviteAsButton = 'show-workspace-invite-as-button',
  ShouldShowModalHeaderBackgrounds = 'should-show-modal-header-backgrounds',
  ShouldShowBreadcrumbsTitleFirst = 'should-show-breadcrumbs-title-first',

  PaletteColors = 'palette-colors',
  PaletteColorMatrix = 'palette-color-matrix',

  BorderRadius = 'border-radius',
  CheckboxBorderRadius = 'checkbox-border-radius',
  Shadow = 'shadow',
  UsePaletteColorsInAvatars = 'use-palette-colors-in-avatars',
  MobileFontSizeFactor = 'mobile-font-size-factor',
  DatabaseTableHeaderDefaultBackgroundColor = 'database-table-header-default-background-color',
  DatabaseTableHeaderHoverBackgroundColor = 'database-table-header-hover-background-color',
  DatabaseTableGridColor = 'database-table-grid-color',
  DatabaseTableFontWeightOffset = 'database-table-font-weight-offset',
  DatabaseTableNameFontWeightOffset = 'database-table-name-font-weight-offset',
  DatabaseTableColumnHeaderFontWeightOffset = 'database-table-column-header-font-weight-offset',
  DatabaseTableNameColor = 'database-table-name-color',
  DatabaseTableStickyShadowColor = 'database-table-sticky-shadow-color',
  DatabaseTableScrollShadowColor = 'database-table-scroll-shadow-color',
  DatabaseTableCardBorderColor = 'database-table-card-border-color',
  DatabaseTableGroupElevation = 'database-table-group-elevation',
  DatabaseTableStickyHeaderElevation = 'database-table-sticky-header-elevation',
  DatabaseTablePinnedColumnElevation = 'database-table-pinned-column-elevation',
  UseDatabaseTableCardLayout = 'use-database-table-card-layout',
  DatabaseCellHoverBackgroundColor = 'database-cell-hover-background-color',
  DatabaseCellHoverBorder = 'database-cell-hover-border',
  DatabaseCellFocusHoverBorder = 'database-cell-focus-hover-border',
  DatabaseRelationIconBackgroundColor = 'database-relation-icon-background-color',
  DatabaseRelationIconBackgroundHoverColor = 'database-relation-icon-background-hover-color',
  DatabaseTableColumnNameAlignment = 'database-table-column-name-alignment',
  FileIconWeightType = 'file-icon-weight-type',
  ShouldClampNotificationTitleItem = 'should-clamp-notification-title-item',
  NotificationIconWeightType = 'notification-icon-weight-type',
  ShowNotificationResourceSpace = 'show-notification-resource-space',
  PreferredIconWeightType = 'preferred-icon-weight-type',
  DatabaseHeaderGroupDropdownPlacement = 'database-header-group-dropdown-placement',
  DashboardRecentListBackgroundColor = 'dashboard-recent-list-background-color',
  DashboardRecentListHorizontalPadding = 'dashboard-recent-list-horizontal-padding',
  ShowDashboardRecentItemBorders = 'show-dashboard-recent-item-borders',
  UseStickyDashboardResourcesButton = 'use-sticky-dashboard-resources-button',
  ShouldShowDashboardAndKanbanInContainer = 'should-show-dashboard-and-kanban-in-container',
  UseDetachedDashboardWidgetTypePreview = 'use-detached-dashboard-widget-type-preview',
  CanCreateConversationDashboardWidget = 'can-create-conversation-dashboard-widget',
  UseCenteredTimeTrackerCellLayout = 'use-centered-time-tracker-cell-layout',
  TimeTrackerDropdownLayoutType = 'time-tracker-dropdown-layout-type',
  ChoosePropertyTypeLayoutType = 'choose-property-type-layout-type',
  StatusDropdownLayoutType = 'status-dropdown-layout-type',
  ItemGroupHeaderLayoutType = 'item-group-header-layout-type',

  // T-946 PR 1A: kolory z JS dobrane dotad do ciemnego tla. Fiord Night / Dark = dzisiejsze wartosci
  // wpisane w komponentach, light-modern = paleta (LightModernThemeVariables + LightModernVariantOverridesMap)
  CalendarEventDefaultColor = 'calendar-event-default-color',
  MapboxStreetStyleUrl = 'mapbox-street-style-url',
  MapPickerMarkerColor = 'map-picker-marker-color',
  MapPickerAreaColor = 'map-picker-area-color',
  ShouldShowModalHeaderComponentBackground = 'should-show-modal-header-component-background',
  TimeTrackerChartBarColor = 'time-tracker-chart-bar-color',
  TimeTrackerChartBarBorderColor = 'time-tracker-chart-bar-border-color',
  TimeTrackerChartLabelStrokeColor = 'time-tracker-chart-label-stroke-color',

  // T-946 PR 1A (tura 2): wykresy Chart.js na dashboardzie. Fiord Night / Dark = to, co wykres rysuje dzis
  // (OnPrimary, ContentDarkest, literaly pluginow sum, domyslne tooltipa Chart.js 4), light-modern = paleta
  // (pochodne palety i atramentu - getLightModernDerivedVariables)
  ChartLabelOnSurfaceColor = 'chart-label-on-surface-color',
  ChartGridColor = 'chart-grid-color',
  ChartTotalBadgeBackgroundColor = 'chart-total-badge-background-color',
  ChartTotalBadgeTextColor = 'chart-total-badge-text-color',
  ChartTooltipBackgroundColor = 'chart-tooltip-background-color',
  ChartTooltipTitleColor = 'chart-tooltip-title-color',
  ChartTooltipBodyColor = 'chart-tooltip-body-color',
  ChartTooltipBorderColor = 'chart-tooltip-border-color',
  ChartTooltipBorderWidth = 'chart-tooltip-border-width',

  // kanwa automatyzacji: modul bez koloru aplikacji, krok w trakcie
  AutomationCanvasDefaultModuleColor = 'automation-canvas-default-module-color',
  AutomationCanvasRunInProgressColor = 'automation-canvas-run-in-progress-color',

  // tablica: cien zagietego rogu karteczki i wypelnienie ramki zaznaczania (marquee)
  WhiteboardStickyNoteFoldShadeColor = 'whiteboard-sticky-note-fold-shade-color',
  WhiteboardMarqueeFillColor = 'whiteboard-marquee-fill-color',

  // wlaczony filtr / sortowanie na kanwie tabeli (plakietki w naglowkach kolumn). Fiord Night / Dark = dzisiejszy
  // przycisk Primary, light-modern = --filter-active-* z light-modern-theme.scss (getLightModernDerivedVariables)
  FilterActiveBackgroundColor = 'filter-active-background-color',
  FilterActiveBackgroundHoverColor = 'filter-active-background-hover-color',
  FilterActiveContentColor = 'filter-active-content-color',
  FilterActiveContentHoverColor = 'filter-active-content-hover-color',
}
